import { NavItem } from '@shared/nav-list-item.component'

export const NAV_ITEMS: NavItem[] = [
  {
    displayName: 'Structured Credit',
    iconName: 'account_tree',
    children: [
      {
        displayName: 'Transactions',
        iconName: 'list_alt',
        route: '/structured-credit/transaction',
        disabled: false,
      },
      {
        displayName: 'Monitoring',
        iconName: 'visibility',
        route: '/structured-credit/monitoring/portfolio',
        disabled: false,
      },
      {
        displayName: 'Revenue',
        iconName: 'payments',
        route: '/structured-credit/revenue/summary',
        disabled: false,
      },
    ],
  },
  {
    displayName: 'Credit SAGE',
    iconName: 'credit_card',
    children: [
      {
        displayName: 'MI',
        children: [
          {
            displayName: 'Pricing Curve',
            iconName: 'show_chart',
            route: '/credit/mi/pricingcurve',
            disabled: false,
          },
          {
            displayName: 'Design',
            iconName: 'design_services',
            route: '/credit/mi/design',
            disabled: false,
          },
          {
            displayName: 'Group',
            iconName: 'workspaces',
            route: '/credit/mi/group',
            disabled: false,
          },
          {
            displayName: 'Compare',
            iconName: 'compare_arrows',
            route: '/credit/mi/compare',
            disabled: false,
          },
          {
            displayName: 'Metrics',
            iconName: 'analytics',
            route: '/credit/mi/metrics',
            disabled: false,
          },
          {
            displayName: 'Submission',
            iconName: 'send',
            route: '/credit/mi/submission',
            disabled: false,
          },
          {
            displayName: 'Monitoring',
            iconName: 'visibility',
            route: '/credit/mi/monitoring',
            disabled: false,
          },
          {
            displayName: 'Quote',
            iconName: 'request_quote',
            route: '/credit/mi/quote',
            disabled: false,
          },
        ],
      },
      {
        displayName: 'GSE',
        children: [
          {
            displayName: 'Pricing Curve',
            iconName: 'show_chart',
            route: '/credit/gse/pricingcurve',
            disabled: false,
          },
          {
            displayName: 'Design',
            iconName: 'design_services',
            route: '/credit/gse/design',
            disabled: false,
          },
          {
            displayName: 'Group',
            iconName: 'workspaces',
            route: '/credit/gse/group',
            disabled: false,
          },
          {
            displayName: 'Compare',
            iconName: 'compare_arrows',
            route: '/credit/gse/compare',
            disabled: false,
          },
          {
            displayName: 'Metrics',
            iconName: 'analytics',
            route: '/credit/gse/metrics',
            disabled: false,
          },
          {
            displayName: 'Submission',
            iconName: 'send',
            route: '/credit/gse/submission',
            disabled: false,
          },
          {
            displayName: 'Monitoring',
            iconName: 'visibility',
            route: '/credit/gse/monitoring',
            disabled: false,
          },
          {
            displayName: 'Quote',
            iconName: 'request_quote',
            route: '/credit/gse/quote',
            disabled: false,
          },
        ],
      },
    ],
  },
  {
    displayName: 'NPI',
    iconName: 'account_balance',
    route: '/npi',
    disabled: false,
  },
  {
    displayName: 'Modeling',
    iconName: 'insights',
    route: '/modeling',
    disabled: false,
  },
  {
    displayName: 'Credit Admin',
    iconName: 'lock',
    route: '/admin/credit',
    disabled: false,
  },
]
